import { HOME_OFFERS_LIST,HOME_OFFERS_SUCCESS, HOME_OFFERS_ERROR} from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchHomeOffersAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}HomeDiscount/GetHomeDiscountList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const homeoffersdetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: HOME_OFFERS_SUCCESS, data: homeoffersdetails });
    } catch (error) {
        yield put({ type: HOME_OFFERS_ERROR, error });
    }
}


export function* watchHomeOffers() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(HOME_OFFERS_LIST, fetchHomeOffersAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchHomeOffers),
    ]);
}